<svelte:options tag={null} />

<script lang="ts">
  import type { TabsAlign, TabsItems, TabsType } from './tabs.types';
  import { EventHandler } from '../../utilities/EventHandler';

  export let align: TabsAlign = 'auto';
  export let description = 'Tabs';
  export let nodivider = false;
  export let tabs: string;
  export let type: TabsType = 'tabs';
  let eventHandler = new EventHandler();
  let tablist: HTMLElement;
  $: parsedTabs = tabs ? (JSON.parse(tabs) as TabsItems[]) : [];

  function setActiveClass(tab: TabsItems): string {
    const tabClasses = ['mc-tabs__element'];

    if (tab.isActive) {
      tabClasses.push('mc-tabs__element--selected');
    }

    if (tab.disabled) {
      tabClasses.push('mc-tabs__element--disabled');
    }

    return tabClasses.join(' ');
  }

  function manageTabs(e: Event, tabItem: TabsItems): void {
    const currentEl = e.target as HTMLElement;

    tablist.querySelectorAll('.mc-tabs__element').forEach((el): void => {
      el.classList.remove('mc-tabs__element--selected');
      el.setAttribute('aria-selected', 'false');
    });

    currentEl.classList.add('mc-tabs__element--selected');
    currentEl.setAttribute('aria-selected', 'true');

    eventHandler.dispatch(
      'tab-clicked',
      Object.assign(tabItem, { target: currentEl }),
    );
  }
</script>

<div
  class="mc-tabs
  {align && align === 'full' ? ' mc-tabs--full' : ''}
  {align && align === 'centered' ? ' mc-tabs--full-centered' : ''}
  {type ? ` mc-tabs--${type}` : ''}{nodivider ? ' mc-tabs--no-divider' : ''}"
>
  <ul
    class="mc-tabs__nav"
    bind:this={tablist}
    role="tablist"
    aria-label={description}
  >
    {#each parsedTabs as tab, index}
      <li class="mc-tabs__item" role="presentation">
        {#if tab.href}
          {#if !tab.disabled}
            <a
              href={tab.href}
              role="tab"
              class={setActiveClass(tab)}
              id={tab.id}
              aria-selected={tab.isActive ? 'true' : 'false'}
              on:click={(event) =>
                manageTabs(event, Object.assign({ index: index }, tab))}
            >
              <span class="mc-tabs__text">
                {tab.text}
              </span>
            </a>
          {:else}
            <span
              role="tab"
              class={setActiveClass(tab)}
              id={tab.id}
              aria-selected={tab.isActive ? 'true' : 'false'}
            >
              <span class="mc-tabs__text">
                {tab.text}
              </span>
            </span>
          {/if}
        {:else}
          <button
            role="tab"
            type="button"
            class={setActiveClass(tab)}
            id={tab.id}
            disabled={tab.disabled}
            aria-selected={tab.isActive ? 'true' : 'false'}
            on:click={(event) =>
              manageTabs(event, Object.assign({ index: index }, tab))}
          >
            <span class="mc-tabs__text">
              {tab.text}
            </span>
          </button>
        {/if}
      </li>
    {/each}
  </ul>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/all-settings';
  @import '@mozaic-ds/styles/components/c.tabs';
</style>
